// extracted by mini-css-extract-plugin
module.exports = {"tip":"tip-module--tip--txdYn","text":"tip-module--text--2yHBn","icon":"tip-module--icon--3YKDf","blue":"tip-module--blue--144Bc"};